import { render, staticRenderFns } from "./StatisticsModule.vue?vue&type=template&id=0108226b&scoped=true"
import script from "./StatisticsModule.vue?vue&type=script&lang=js"
export * from "./StatisticsModule.vue?vue&type=script&lang=js"
import style0 from "./StatisticsModule.vue?vue&type=style&index=0&id=0108226b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108226b",
  null
  
)

export default component.exports